import ErrorIcon from '../assets/error.svg?raw'
import SuccessIcon from '../assets/success.svg?raw'

// Add spinner styles to the document
const addSpinnerStyles = () => {
  if (document.getElementById('newsletter-spinner-styles')) return;
  
  const style = document.createElement('style');
  style.id = 'newsletter-spinner-styles';
  style.textContent = `
    .spinner {
      width: 16px;
      height: 16px;
      border: 2px solid;
      border-bottom-color: transparent !important;
      border-radius: 50%;
      display: inline-block;
      animation: rotation 1s linear infinite;
      margin-left: 8px;
      vertical-align: middle;
      flex-shrink: 0;
    }
    
    .newsletter-submit-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;
  document.head.appendChild(style);
};

export class UserMessageService {
    errorContainerClass = ".nl-subscription_error-message";
    successContainerClass = ".newsletter_signup-success_message";
    newsletterFormClass = ".newsletter-form";
    submitButtonClass = ".newsletter-submit-button";

    public showErrorMessage = (message: string, container?: HTMLElement) => {
        const targetContainer = container || document;
        const errorMessage: HTMLDivElement | null = targetContainer.querySelector(`${this.errorContainerClass}`);
        const newsletterForm: HTMLFormElement | null = targetContainer.querySelector(`${this.newsletterFormClass}`);
        if (!errorMessage || !newsletterForm) { throw new Error("Error message div or newsletter form not found"); }

        errorMessage.innerHTML = `${ErrorIcon} ${message}`;
        errorMessage.style.display = "flex";
        newsletterForm.style.border = "1px solid #F55536";
        newsletterForm.style.boxSizing = "border-box";
    }

    public showSuccessMessage = (message: string, container?: HTMLElement) => {
        const targetContainer = container || document;
        const successMessage: HTMLDivElement | null = targetContainer.querySelector(`${this.successContainerClass}`);
        const newsletterForm: HTMLFormElement | null = targetContainer.querySelector(`${this.newsletterFormClass}`);
        if (!successMessage || !newsletterForm) { throw new Error("Success message div or newsletter form not found"); }

        successMessage.innerHTML = `${SuccessIcon} ${message}`;
        successMessage.style.display = "flex";
        newsletterForm.style.border = "1px solid #9FC507";
        newsletterForm.style.boxSizing = "border-box";
    }

    public hideMessages = (container?: HTMLElement) => {
        const targetContainer = container || document;
        const errorMessage: HTMLDivElement | null = targetContainer.querySelector(`${this.errorContainerClass}`);
        const successMessage: HTMLDivElement | null = targetContainer.querySelector(`${this.successContainerClass}`);

        if (errorMessage) errorMessage.style.display = "none";
        if (successMessage) successMessage.style.display = "none";
    }

    public setButtonLoading = (button: HTMLButtonElement | HTMLAnchorElement, loading: boolean, spinnerColor: string): void => {
        if (!button) return;

        // Ensure spinner styles are added to the document
        addSpinnerStyles();

        if (loading) {
            const spinner = document.createElement('span');
            spinner.className = 'spinner';
            spinner.style.borderColor = spinnerColor;
            spinner.style.borderBottomColor = 'transparent';
            spinner.id = 'loading-spinner';

            button.setAttribute('disabled', 'true');
            button.style.pointerEvents = 'none';

            // Store original text
            const originalText = button.textContent || '';
            button.setAttribute('data-original-text', originalText);

            // Clear button and add text + spinner
            button.innerHTML = '';
            const textNode = document.createTextNode(originalText);
            button.appendChild(textNode);
            button.appendChild(spinner);
        } else {
            button.removeAttribute('disabled');
            button.style.pointerEvents = 'auto';

            // Restore original text
            const originalText = button.getAttribute('data-original-text') || '';
            button.innerHTML = originalText;
            button.removeAttribute('data-original-text');
        }
    }
    
    public setSubmitButtonLoading = (loading: boolean, container?: HTMLElement): void => {
        const targetContainer = container || document;
        const button = targetContainer.querySelector(this.submitButtonClass) as HTMLButtonElement;
        if (button) {
            this.setButtonLoading(button, loading, "var(--white)");
        }
    }
}

export const userMessageService = new UserMessageService();
